var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeamlessIntegrationWithCbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 187,
    viewBox: "0 0 237 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 236.333,
    height: 187,
    rx: 16,
    fill: "#EFEBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3333,
    y: 24,
    width: 188.333,
    height: 139,
    rx: 16.3778,
    fill: "#DED6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3331 93C54.3331 96.6819 57.3179 99.6667 60.9998 99.6667C64.6817 99.6667 67.6664 96.6819 67.6664 93C67.6664 89.3181 64.6817 86.3333 60.9998 86.3333C57.3179 86.3333 54.3331 89.3181 54.3331 93ZM169.333 93C169.333 96.6819 172.318 99.6667 176 99.6667C179.682 99.6667 182.666 96.6819 182.666 93C182.666 89.3181 179.682 86.3333 176 86.3333C172.318 86.3333 169.333 89.3181 169.333 93ZM60.9998 94.25H176V91.75H60.9998V94.25Z",
    fill: "#6743E0",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.208 134.867L100.208 136.117L101.458 136.117L101.458 134.867L100.208 134.867ZM80.3672 130.645C78.0357 127.795 73.8356 127.375 70.9859 129.707C68.1363 132.039 67.7163 136.239 70.0478 139.088C72.3793 141.938 76.5795 142.358 79.4291 140.026C82.2787 137.695 82.6988 133.495 80.3672 130.645ZM98.9578 107.867L98.9577 134.867L101.458 134.867L101.458 107.867L98.9578 107.867ZM100.208 133.617L75.2075 133.617L75.2075 136.117L100.208 136.117L100.208 133.617Z",
    fill: "#6743E0",
    fillOpacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.44 134.867L137.44 136.117L136.19 136.117L136.19 134.867L137.44 134.867ZM157.281 130.645C159.612 127.795 163.812 127.375 166.662 129.707C169.512 132.039 169.932 136.239 167.6 139.088C165.269 141.938 161.068 142.358 158.219 140.026C155.369 137.695 154.949 133.495 157.281 130.645ZM138.69 107.867L138.69 134.867L136.19 134.867L136.19 107.867L138.69 107.867ZM137.44 133.617L162.44 133.617L162.44 136.117L137.44 136.117L137.44 133.617Z",
    fill: "#6743E0",
    fillOpacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.208 52.3663L100.208 51.1163L101.458 51.1163L101.458 52.3663L100.208 52.3663ZM80.3672 56.588C78.0357 59.4377 73.8356 59.8577 70.9859 57.5262C68.1363 55.1947 67.7163 50.9945 70.0478 48.1449C72.3793 45.2952 76.5795 44.8752 79.4291 47.2067C82.2787 49.5383 82.6988 53.7384 80.3672 56.588ZM98.9578 79.3664L98.9577 52.3663L101.458 52.3663L101.458 79.3664L98.9578 79.3664ZM100.208 53.6163L75.2075 53.6165L75.2075 51.1165L100.208 51.1163L100.208 53.6163Z",
    fill: "#6743E0",
    fillOpacity: 0.55
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.44 52.3663L137.44 51.1163L136.19 51.1163L136.19 52.3663L137.44 52.3663ZM157.281 56.588C159.612 59.4377 163.812 59.8577 166.662 57.5262C169.512 55.1947 169.932 50.9945 167.6 48.1449C165.269 45.2952 161.068 44.8752 158.219 47.2067C155.369 49.5383 154.949 53.7384 157.281 56.588ZM138.69 79.3664L138.69 52.3663L136.19 52.3663L136.19 79.3664L138.69 79.3664ZM137.44 53.6163L162.44 53.6165L162.44 51.1165L137.44 51.1163L137.44 53.6163Z",
    fill: "#6743E0",
    fillOpacity: 0.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.333,
    y: 53,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#3E2C7B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.769 113.451H144.897V118.564H93.769V113.451ZM98.8818 93.0002H103.995V110.895H98.8818V93.0002ZM111.664 93.0002H116.777V110.895H111.664V93.0002ZM121.889 93.0002H127.002V110.895H121.889V93.0002ZM134.671 93.0002H139.784V110.895H134.671V93.0002ZM93.769 80.2182L119.333 67.4363L144.897 80.2182V90.4438H93.769V80.2182ZM119.333 82.7746C120.745 82.7746 121.889 81.6301 121.889 80.2182C121.889 78.8064 120.745 77.6618 119.333 77.6618C117.921 77.6618 116.777 78.8064 116.777 80.2182C116.777 81.6301 117.921 82.7746 119.333 82.7746Z",
    fill: "url(#paint0_linear_465_3694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_3694",
    x1: 119.333,
    y1: 67.4363,
    x2: 119.333,
    y2: 118.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessIntegrationWithCbs);
export default __webpack_public_path__ + "static/media/seamless-integration-with-cbs.d74b396ba50d4248bc284edd6486eaff.svg";
export { ForwardRef as ReactComponent };